import { render, staticRenderFns } from "./GatheringStep1.vue?vue&type=template&id=b53fd80a&scoped=true&"
import script from "./GatheringStep1.vue?vue&type=script&lang=js&"
export * from "./GatheringStep1.vue?vue&type=script&lang=js&"
import style0 from "./GatheringStep1.vue?vue&type=style&index=0&id=b53fd80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53fd80a",
  null
  
)

export default component.exports